import axios from "axios";


export const get_all_notices = async () => {
    const url = `https://6grw6zjp4e.execute-api.us-east-1.amazonaws.com/prod/avisos_od2/confirm`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: sessionStorage.getItem("getIdTokenRefresh"),
          "access-token": sessionStorage.getItem("getAccesTokenRefresh"),
          "Content-Type": "application/json",
        },
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  };



  export const post_confirm_notices = async (data) => {
    const url = `https://6grw6zjp4e.execute-api.us-east-1.amazonaws.com/prod/avisos_od2/confirm`;
    try {
      const response = await axios.post(url,data, {
        headers: {
          Authorization: sessionStorage.getItem("getIdTokenRefresh"),
          "access-token": sessionStorage.getItem("getAccesTokenRefresh"),
          "Content-Type": "application/json",
        },
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const put_confirm_notices = async (data) => {
    const url = `https://6grw6zjp4e.execute-api.us-east-1.amazonaws.com/prod/avisos_od2/confirm`;
    try {
      const response = await axios.put(url,data, {
        headers: {
          Authorization: sessionStorage.getItem("getIdTokenRefresh"),
          "access-token": sessionStorage.getItem("getAccesTokenRefresh"),
          "Content-Type": "application/json",
        },
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  };


  export const put_send_email = async (data) => {
    const url = `https://6grw6zjp4e.execute-api.us-east-1.amazonaws.com/prod/avisos_od2`;
    try {
      const response = await axios.put(url, data, {
        headers: {
          Authorization: sessionStorage.getItem("getIdTokenRefresh"),
          "access-token": sessionStorage.getItem("getAccesTokenRefresh"),
          "Content-Type": "application/json",
        },
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  
  
export const get_deatils_notices = async (id) => {
  const url = `https://6grw6zjp4e.execute-api.us-east-1.amazonaws.com/prod/avisos_od2/read?id=${id}`;
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("getIdTokenRefresh"),
        "access-token": sessionStorage.getItem("getAccesTokenRefresh"),
        "Content-Type": "application/json",
      },
    });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};


  
export const post_jira_images = async (data) => {
  const url = `https://tavmr1hck9.execute-api.us-east-1.amazonaws.com/prod/jira/images`;
  try {
    const response = await axios.post(url, data, {
      headers: {
        // Authorization: sessionStorage.getItem("getIdTokenRefresh"),
        // "access-token": sessionStorage.getItem("getAccesTokenRefresh"),
        "Content-Type": "application/json",
      },
    });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};


  
export const test_red_get = async (type) => {
  const url = `https://y9nhd9v0zd.execute-api.us-east-1.amazonaws.com/prod/traffic?type=${type}`;
  try {
    const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
    });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};


